import { getFormIdFromUrl } from "../../helpers/getUrlParams";
import { api } from "../api";
import { ApiDynamicPaths } from "../api/paths";
import { AddFieldResponse } from "./fields.service.d";
import { IField } from "../../store/fields/types";
import { IMarker } from "../../store/markers/types";
import { ISelectableOption } from "../../store/fields/boomtypes";
import { ISelectableOptionState, IBulkOptions } from "../../store/selectableOptions/types";

export class FieldsService {
    /**
     * Add Field request
     *
     * @param  {IBoomformField} createPageRequestData
     */
    static async addField(data: any): Promise<AddFieldResponse> {
        return api.post(ApiDynamicPaths({ form_id: getFormIdFromUrl() }).ADD_FIELD, data);
    }

    /**
     * Add Field request
     *
     * @param  {data : any } duplicateFieldRequestData
     */
    static async duplicateField(data: any): Promise<AddFieldResponse> {
        return api.put(ApiDynamicPaths({ form_id: getFormIdFromUrl() }).DUPLICATE_FIELD, data);
    }

    /**
     * Update Field request
     *
     * @param  {IAddFieldData} updatePageRequestData
     * Partial<IField> & IBoomformField
     */
    static async updateField(_id: IField["_id"], data: any): Promise<AddFieldResponse> {
        return api.put(ApiDynamicPaths({ form_id: getFormIdFromUrl(), field_id: _id }).UPDATE_FIELD, data);
    }

    /**
     * Update Field request
     *
     * @param  {IAddFieldData} updatePageRequestData
     * Partial<IField> & IBoomformField
     */
    static async deleteField(_id: IField["_id"]): Promise<AddFieldResponse> {
        return api.delete(ApiDynamicPaths({ form_id: getFormIdFromUrl(), field_id: _id }).DELETE_FIELD);
    }

    /**
     * Add option request
     *
     * @param  {IAddOptionData} addOptionRequestData
     * Partial<IField> & IBoomformField
     */
    static async addOption(_id: IField["_id"], data: ISelectableOption): Promise<AddFieldResponse> {
        return api.post(ApiDynamicPaths({ form_id: getFormIdFromUrl(), field_id: _id }).ADD_SELECTABLE_OPTIONS, data);
    }

    /**
     * Add Bulk option request
     *
     * @param  {IAddBulkOptionData} addBulkOptionRequestData
     * Partial<IField> & IBoomformField
     */
    static async addBulkOptions(_id: IField["_id"], data: IBulkOptions): Promise<AddFieldResponse> {
        return api.post(ApiDynamicPaths({ form_id: getFormIdFromUrl(), field_id: _id }).ADD_SELECTABLE_OPTIONS, data);
    }

    /**
     * Delete option request
     *
     * @param  {IDeleteOptionData} addOptionRequestData
     * Partial<IField> & IBoomformField
     */
    static async deleteOption(_id: IField["_id"], option_id: string): Promise<AddFieldResponse> {
        return api.delete(
            ApiDynamicPaths({ form_id: getFormIdFromUrl(), field_id: _id, option_id }).DELETE_SELECTABLE_OPTION,
        );
    }

    /**
     * Delete Bulk option request
     *
     * @param  {IDeleteBulkOptionsData} deleteBulkOptions
     * Partial<IField> & IBoomformField
     */
    static async deleteBulkOptions(_id: IField["_id"]): Promise<AddFieldResponse> {
        return api.delete(
            ApiDynamicPaths({ form_id: getFormIdFromUrl(), field_id: _id }).DELETE_BULK_SELECTABLE_OPTIONS,
        );
    }

    /**
     * Update option request
     *
     * @param  {IUpdateOptionData} addOptionRequestData
     * Partial<IField> & IBoomformField
     */
    static async updateOption(
        _id: IField["_id"],
        option_id: string,
        data: ISelectableOptionState,
    ): Promise<AddFieldResponse> {
        return api.put(
            ApiDynamicPaths({ form_id: getFormIdFromUrl(), field_id: _id, option_id }).UPDATE_SELECTABLE_OPTIONS,
            data,
        );
    }

    /**
     * Order option request
     *
     * @param  {IOrderOptionData} addOptionRequestData
     * Partial<IField> & IBoomformField
     */
    static async orderOption(_id: IField["_id"], option_id: string, newPosition: number): Promise<AddFieldResponse> {
        return api.post(
            ApiDynamicPaths({ form_id: getFormIdFromUrl(), field_id: _id, option_id }).ORDER_SELECTABLE_OPTIONS,
            {
                position: newPosition,
            },
        );
    }

    /**
     * Add marker request
     *
     * @param  {IAddMarkerData} addMarkerRequestData
     * Partial<IField> & IBoomformField
     */
    static async addMarker(_id: IField["_id"], data: IMarker): Promise<AddFieldResponse> {
        return api.post(ApiDynamicPaths({ form_id: getFormIdFromUrl(), field_id: _id }).ADD_MARKER, data);
    }

    /**
     * Delete marker request
     *
     * @param  {IDeleteMarkerData} addOptionRequestData
     * Partial<IField> & IBoomformField
     */
    static async deleteMarker(_id: IField["_id"], marker_id: string): Promise<AddFieldResponse> {
        return api.delete(ApiDynamicPaths({ form_id: getFormIdFromUrl(), field_id: _id, marker_id }).DELETE_MARKER);
    }

    /**
     * Update marker request
     *
     * @param  {IUpdateMarkerData} addMarkerRequestData
     * Partial<IField> & IBoomformField
     */
    static async updateMarker(_id: IField["_id"], marker_id: string, data: IMarker): Promise<AddFieldResponse> {
        return api.put(ApiDynamicPaths({ form_id: getFormIdFromUrl(), field_id: _id, marker_id }).UPDATE_MARKER, data);
    }

    /**
     * Order marker request
     *
     * @param  {IOrderMarkerData} addMarkerRequestData
     * Partial<IField> & IBoomformField
     */
    static async orderMarker(_id: IField["_id"], marker_id: string, newPosition: number): Promise<AddFieldResponse> {
        return api.post(ApiDynamicPaths({ form_id: getFormIdFromUrl(), field_id: _id, marker_id }).ORDER_MARKERS, {
            position: newPosition,
        });
    }
}
